import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { tamanioGrafica } from "utils/generalFunctions";
import { convertirFecha } from "utils/generalFunctions";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Barchart = ({ dataGrafica }) => {
  const [datos, setDatos] = useState(null);
  const [labelsGrafica, setLabelsGrafica] = useState([]);
  const [maxYGrafica, setmaxYGrafica] = useState(0);
  const [datosGrafica, setDatosGrafica] = useState([]);

  useEffect(() => {
    setDatos(dataGrafica);
  }, [dataGrafica]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
    },
    scales: {
      y: {
        min: 0,
        max: maxYGrafica,
      },
      x: {
        ticks: { color: "rgb(255, 99, 132)" },
      },
    },
  };

  useEffect(() => {
    let labelsHoras = [];
    let datosGrafica = [];
    if (dataGrafica.length > 0) {
      datos?.forEach((dato) => {
        labelsHoras.push(dato.fecha);
        datosGrafica.push(dato.eTot);
      });

      setLabelsGrafica([...labelsHoras]);
      setDatosGrafica([...datosGrafica]);

      const maximoY = datos?.reduce((previous, current) => {
        return current.eTot > previous.eTot ? current : previous;
      });
      setmaxYGrafica(Math.round((maximoY?.eTot + 20) / 10) * 10);
    }
  }, [datos]);
  const labels = labelsGrafica;

  const dataG = {
    labels,
    datasets: [
      {
        label: "Potencia",
        data: datosGrafica,
        backgroundColor: "rgb(75, 138, 169)",
      },
    ],
  };

  useEffect(() => {}, [datos]);

  return (
    <div className="w-100 flex justify-center pl-md-5 pr-md-5">
      <Bar height={tamanioGrafica()} options={options} data={dataG} />
    </div>
  );
};

export default Barchart;
